export default __webpack_public_path__ + "static/media/opinion5.3f577d96.jpg";